import WaitForAuthPr from './WaitForAuthPr';

export default WaitForAuthPr;
